"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _polished = require("polished");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _dist = require("@low6dev/react-utils/dist");

require("moment/locale/nl");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledPopup = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 1;\n  left: 50%;\n  top: 14rem;\n  transform: translate(-50%, -50%);\n  width: 94%;\n  box-shadow: 0px 16px 40px rgba(0, 0, 0, 0.1);\n  border-radius: ", ";\n  display: flex;\n  overflow: hidden;\n  flex-direction: column;\n  background: ", ";\n\n  @media (min-width: ", ") {\n    width: 70%;\n  }\n\n  @media (min-width: ", ") {\n    width: 55%;\n  }\n\n  @media (min-width: ", ") {\n    width: 75%;\n  }\n"])), function (p) {
  return p.theme.borderRadius;
}, function (p) {
  return p.theme.colorCardBackground;
}, function (props) {
  return props.theme.screenWidthXs;
}, function (props) {
  return props.theme.screenWidthSm;
}, function (props) {
  return props.theme.screenWidthMd;
});

var StyledHeader = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: 1rem;\n  background: ", ";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])), function (p) {
  return p.theme.colorDark;
});

var StyledKickOff = _styledComponents.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  font-size: 1rem;\n  color: ", ";\n  font-weight: bold;\n  white-space: nowrap;\n  margin-right: 2rem;\n  span {\n    color: ", ";\n    font-size: 0.75rem;\n    line-height: 1.3;\n    margin-bottom: 0.125rem;\n  }\n"])), function (p) {
  return p.theme.colorDarkText;
}, function (p) {
  return (0, _polished.rgba)(p.theme.colorDarkText, 0.75);
});

var StyledLive = _styledComponents.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  border-radius: 0.25rem;\n  padding: 0.4rem;\n  background: ", ";\n  text-transform: uppercase;\n  white-space: nowrap;\n  font-size: 0.625rem;\n  font-weight: bold;\n  color: ", ";\n  &:before {\n    content: \"\";\n    width: 0.5rem;\n    height: 0.5rem;\n    border-radius: 50%;\n    margin-right: 0.5rem;\n    display: inline-block;\n    background: ", ";\n  }\n"])), function (p) {
  return p.theme.colorDisabledBackground;
}, function (p) {
  return p.isLive ? p.theme.colorText : p.theme.colorDisabledText;
}, function (p) {
  return p.isLive ? "#55c164" : p.theme.colorDisabledText;
});

var StyledTeams = _styledComponents.default.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  padding: 1rem;\n  display: flex;\n  align-items: center;\n  position: relative;\n  &:after {\n    content: \"\";\n    display: block;\n    width: 85%;\n    left: 50%;\n    transform: translate(-50%, 0);\n    position: absolute;\n    bottom: 0;\n    height: 0.0625rem;\n    background: ", ";\n  }\n"])), function (p) {
  return p.theme.colorBorder;
});

var StyledClub = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n"])));

var StyledClubLogo = _styledComponents.default.img(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  height: 2.875rem;\n  margin-bottom: 0.25rem;\n"])));

var StyledClubName = (0, _styledComponents.default)(_fiverReactUiComponents.ClubName)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-size: 0.625rem;\n  line-height: 1.2;\n  text-align: center;\n  letter-spacing: 0.04em;\n"])));

var StyledVs = _styledComponents.default.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  width: 60px;\n  text-align: center;\n  color: ", ";\n  font-size: 1.375rem;\n  font-weight: bold;\n"])), function (p) {
  return p.theme.colorLabel;
});

var StyledMessage = _styledComponents.default.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  padding: 1.5rem 2rem 1.5rem;\n  color: ", ";\n  font-size: 1rem;\n  line-height: 1.5;\n  text-align: center;\n  max-width: 230px;\n  margin: 0 auto;\n"])), function (p) {
  return p.theme.colorLabel;
});

var StyleSpinnerWrapper = _styledComponents.default.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  padding: 0 2.25rem;\n  flex: 1 1 auto;\n"])));

var StyledSpinner = (0, _styledComponents.default)(_fiverReactUiComponents.Spinner)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  border-top-color: ", ";\n"])), function (p) {
  return p.theme.colorPrimary;
});

var StyledSpinnerText = _styledComponents.default.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  font-size: 0.875rem;\n  line-height: 1.25;\n"])), function (p) {
  return p.theme.fontWeightSemibold;
});

var Wrapper = function Wrapper(_ref) {
  var _activePickem$sportMa, _activePickem$sportMa2, _activePickem$sportMa3, _activePickem$sportMa4, _activePickem$sportMa5, _activePickem$sportMa6, _activePickem$sportMa7, _activePickem$sportMa8, _activePickem$sportMa9, _activePickem$sportMa10, _activePickem$sportMa11, _activePickem$sportMa12, _activePickem$sportMa13, _activePickem$sportMa14, _activePickem$sportMa15, _activePickem$sportMa16, _activePickem$sportMa17;

  var translations = _ref.translations,
      language = _ref.language,
      betbar = _ref.betbar,
      isUsingAlternativeImages = _ref.isUsingAlternativeImages;
  var activePickem = betbar.activePickem,
      activeBet = betbar.activeBet,
      isActivePickemCompleted = betbar.isActivePickemCompleted,
      isActivePickemInPlay = betbar.isActivePickemInPlay,
      isActivePickemApproved = betbar.isActivePickemApproved;
  var statusText = (activePickem === null || activePickem === void 0 ? void 0 : (_activePickem$sportMa = activePickem.sportMatch) === null || _activePickem$sportMa === void 0 ? void 0 : _activePickem$sportMa.period) !== "HalfTime" || (activePickem === null || activePickem === void 0 ? void 0 : (_activePickem$sportMa2 = activePickem.sportMatch) === null || _activePickem$sportMa2 === void 0 ? void 0 : _activePickem$sportMa2.period) !== "HalfTime" ? "Live" : translations.ended;
  var locale, timezone;

  if (language === "dutch") {
    locale = "nl";
    timezone = "Europe/Amsterdam";
  } // uncomment to test
  // activePickem.status = "IN_PLAY";


  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledPopup, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledHeader, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledKickOff, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: isActivePickemInPlay ? "".concat(activePickem === null || activePickem === void 0 ? void 0 : (_activePickem$sportMa3 = activePickem.sportMatch) === null || _activePickem$sportMa3 === void 0 ? void 0 : _activePickem$sportMa3.matchTime, "'") : isActivePickemCompleted ? translations.ended : translations.start
        }), !isActivePickemApproved ? "".concat(statusText, " ").concat(activePickem === null || activePickem === void 0 ? void 0 : (_activePickem$sportMa4 = activePickem.sportMatch) === null || _activePickem$sportMa4 === void 0 ? void 0 : _activePickem$sportMa4.homeScore, ":").concat(activePickem === null || activePickem === void 0 ? void 0 : (_activePickem$sportMa5 = activePickem.sportMatch) === null || _activePickem$sportMa5 === void 0 ? void 0 : _activePickem$sportMa5.awayScore) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_fiverReactUiComponents.DateTime, {
          locale: locale,
          format: "ddd H:mm",
          timezone: timezone,
          children: activePickem === null || activePickem === void 0 ? void 0 : activePickem.start
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledLive, {
        isLive: isActivePickemInPlay,
        children: "LIVE"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledTeams, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledClub, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledClubLogo, {
          src: (activePickem === null || activePickem === void 0 ? void 0 : (_activePickem$sportMa6 = activePickem.sportMatch) === null || _activePickem$sportMa6 === void 0 ? void 0 : (_activePickem$sportMa7 = _activePickem$sportMa6.homeTeam) === null || _activePickem$sportMa7 === void 0 ? void 0 : _activePickem$sportMa7.logoImg) || (activePickem === null || activePickem === void 0 ? void 0 : (_activePickem$sportMa8 = activePickem.sportMatch) === null || _activePickem$sportMa8 === void 0 ? void 0 : (_activePickem$sportMa9 = _activePickem$sportMa8.homeTeam) === null || _activePickem$sportMa9 === void 0 ? void 0 : _activePickem$sportMa9.logo)
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledClubName, {
          isAbbreviated: true,
          children: activePickem === null || activePickem === void 0 ? void 0 : (_activePickem$sportMa10 = activePickem.sportMatch) === null || _activePickem$sportMa10 === void 0 ? void 0 : (_activePickem$sportMa11 = _activePickem$sportMa10.homeTeam) === null || _activePickem$sportMa11 === void 0 ? void 0 : _activePickem$sportMa11.name
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledVs, {
        children: "vs"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledClub, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledClubLogo, {
          src: (activePickem === null || activePickem === void 0 ? void 0 : (_activePickem$sportMa12 = activePickem.sportMatch) === null || _activePickem$sportMa12 === void 0 ? void 0 : (_activePickem$sportMa13 = _activePickem$sportMa12.awayTeam) === null || _activePickem$sportMa13 === void 0 ? void 0 : _activePickem$sportMa13.logoImg) || (activePickem === null || activePickem === void 0 ? void 0 : (_activePickem$sportMa14 = activePickem.sportMatch) === null || _activePickem$sportMa14 === void 0 ? void 0 : (_activePickem$sportMa15 = _activePickem$sportMa14.awayTeam) === null || _activePickem$sportMa15 === void 0 ? void 0 : _activePickem$sportMa15.logo)
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledClubName, {
          isAbbreviated: true,
          children: activePickem === null || activePickem === void 0 ? void 0 : (_activePickem$sportMa16 = activePickem.sportMatch) === null || _activePickem$sportMa16 === void 0 ? void 0 : (_activePickem$sportMa17 = _activePickem$sportMa16.awayTeam) === null || _activePickem$sportMa17 === void 0 ? void 0 : _activePickem$sportMa17.name
        })]
      })]
    }), isActivePickemInPlay ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyleSpinnerWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledSpinnerText, {
        children: [translations.awaiting, " ", /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), " ", translations.updates, "..."]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledSpinner, {
        lineWidth: 5
      })]
    }) : isActivePickemApproved ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledMessage, {
      children: translations.pleaseTuneIn
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledMessage, {
      children: [translations.rank, " ", (0, _dist.ordinalSuffix)(activeBet === null || activeBet === void 0 ? void 0 : activeBet.rank)]
    })]
  });
};

var _default = Wrapper;
exports.default = _default;